var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-table',{attrs:{"border-y":"","row-style-option":_vm.rowStyleOption,"columns":_vm.columns,"table-data":_vm.tableData,"max-height":"calc(100vh - 2.5rem)","cell-style-option":_vm.cellStyleOption}})}
var staticRenderFns = []

export { render, staticRenderFns }